import React, { useRef, useEffect } from "react";
import ThinkingAnimation from "components/util/helpers/ThinkingAnimation";

const ConversationStreamingMessage = ({ activityText = "", thinkingText = "", streamingText = "", isStreaming = false, agentName = "Workix" }) => {

  const wrapperRef = useRef(null);

  useEffect(() => {
    wrapperRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
  }, [thinkingText, streamingText]);

  return (
    <div ref={wrapperRef} className="w-100">
      <div className="message-wrapper thinking-animation-wrapper animate__animated animate__fadeIn animate__faster mx-0 mx-sm-2">
        <ThinkingAnimation
          activityText={activityText}
          thinkingText={thinkingText}
          outputText={streamingText}
          isStreaming={isStreaming}
          agentName={agentName}
        />
      </div>
    </div>
  );
};

export default ConversationStreamingMessage;
